<template>
	<div>
		<div class="pd30">
			<div class="mt20 mb20">
				<a-form layout="inline">
					<a-form-item label="所属门店">
						<div>
							<a-select style="width: 120px" placeholder="请选择" v-model="search.mendian_id">
								<a-select-option :value="0">请选择</a-select-option>
								<a-select-option :value="item.mendian_id" v-for="(item,index) in mendians" :key="index">{{item.name}}</a-select-option>
							</a-select>
						</div>
					</a-form-item>

					<a-form-item label="员工名称">
						<a-input v-model="search.keyword" placeholder="请输入员工名称"></a-input>
					</a-form-item>
					
					<a-form-item>
						<a-button @click="searchAct" type="primary">查询</a-button>
						<a-button @click="cancelAct" class="ml10">取消</a-button>
					</a-form-item>
				</a-form>
			</div>
			<div class="flex alcenter">
				<a-button type="primary" icon="plus" @click="addStaffAct()">添加员工</a-button>
				
				<!-- <div class="flex alcenter ml20">
					<div class="ft14 ftw500 cl-info">员工管理入口：</div>
					<div v-if="miniapp_status > 0" class="ft14 ftw500 cl-main">访问您的微信小程序 > 我的 > 员工管理入口</div>
					<div class="ml8">
						<show-code :status="miniapp_status" path="/pages/client/member/index"></show-code>
					</div>
				</div> -->
				
			</div>
			
			<div class="mt20">
				<div class="wxb-table-gray">
					<a-table rowKey="staff_id" :columns="columns" :pagination="pagination" @change="handleTableChange" :data-source="datas"
					 :loading="loading">
					 
						<template slot="status" slot-scope="text,record">
							<div class="flex center">
								<div v-if="text==1" class="ft14 ftw400 cl-black">在职</div>
								<div v-else-if="text==2" class="ft14 ftw400 cl-notice">离职</div>
								<div v-else-if="text==3" class="ft14 ftw400 cl-black">休假</div>
								<div v-else class="ft14 ftw400 cl-black">-</div>
							</div>
						</template>

						<template slot="mendian_slot" slot-scope="text,record">
							{{text ? text.name : '-'}}
						</template>

						<template slot="sex_slot" slot-scope="text,record">
							<div class="flex center">
								<div v-if="text==0" class="ft14 ftw400 cl-black">未知</div>
								<div v-else-if="text==1" class="ft14 ftw400 cl-black">男</div>
								<div v-else-if="text==2" class="ft14 ftw400 cl-black">女</div>
								<div v-else class="ft14 ftw400 cl-black">-</div>
							</div>
						</template>

						<template slot="is_admin_slot" slot-scope="text,record">
							<div class="flex center">
								<div v-if="text==0" class="ft14 ftw400 cl-notice">否</div>
								<div v-else-if="text==1" class="ft14 ftw400 cl-black">是</div>
							</div>
						</template>

						<template slot="action" slot-scope="record,index">
							<div class="flex center">
								<a-dropdown placement="bottomRight">
									<span class="more-act">
										<i class="iconfont iconmore_gray"></i>
									</span>
									<a-menu slot="overlay">
										<a-menu-item @click="editStaffAct(record)"  v-if="[1,3].includes(record.status)">
											<a class="menu-act" href="javascript:;">
												<i class="iconfont ft14 iconedit"></i>
												<span class="ml10">编辑账号</span>
											</a>
										</a-menu-item>
										<a-menu-item @click="delAct(record)"  v-if="[1,3].includes(record.status)">
											<a class="menu-act" href="javascript:;">
												<i class="iconfont ft14 iconapplication_tab01"></i>
												<span class="ml10">删除账号</span>
											</a>
										</a-menu-item>
									
						
									</a-menu>
								</a-dropdown>
							</div>
						</template>

						<template slot="role_slot" slot-scope="text,record">
							{{ getRoleLabel(text) }}
						</template>

					</a-table>
				</div>
			</div>
			
			<div v-if="editStaffLoading">
				<edit-staff :staff_id="staff_id" :visible="editStaffLoading" @cancel="cancelEditStaff" @ok="okEditStaff"></edit-staff>
			</div>
		
		</div>
	</div>
</template>

<script>
	import {
		listMixin
	} from '../../../../common/mixin/list.js';
	import editStaff from './modal/staff/editStaff.vue';
	import showCode from '../../../../components/code/miniqrcode.vue';
	
	export default {
		components:{
			editStaff,
			showCode,
		},
		mixins: [listMixin],
		data() {
			return {
				loading: false,
				editStaffLoading:false,
				showMiniappLoading:false,
				staff_id:0,
				miniapp_status:0,
				pagination: {
					current: 1,
					pageSize: 10, //每页中显示10条数据
					total: 0,
				},
				columns: [
					{
						title: '姓名',
						dataIndex: 'name',
						align: 'center',
						ellipsis: true
					},
					{
						title: '手机号',
						dataIndex: 'mobile',
						align: 'center',
						ellipsis: true
					},
					// {
					// 	title: '权限',
					// 	dataIndex: 'jurisdiction',
					// 	align: 'center',
					// 	ellipsis: true
					// },
					{
						title: '状态',
						dataIndex: 'status',
						align: 'center',
						scopedSlots: {
							customRender: 'status'
						}
					},
					{
						title: '所属门店',
						dataIndex: 'mendian',
						align: 'center',
						scopedSlots: {
							customRender: 'mendian_slot'
						}
					},
					{
						title: '所属角色',
						dataIndex: 'role',
						align: 'center',
						scopedSlots: {
							customRender: 'role_slot'
						}
					},
					{
						title: '所属岗位',
						dataIndex: 'job',
						align: 'center',
						scopedSlots: {
							customRender: 'job_slot'
						}
					},
					{
						title: '性别',
						dataIndex: 'sex',
						align: 'center',
						scopedSlots: {
							customRender: 'sex_slot'
						}
					},
					{
						title: '超级管理员',
						dataIndex: 'is_admin',
						align: 'center',
						scopedSlots: {
							customRender: 'is_admin_slot'
						}
					},
					{
						title: '添加时间',
						dataIndex: 'add_time_format',
						align: 'center',
						ellipsis: true
					},
					{
						title: '操作',
						key: 'action',
						align: 'center',
						scopedSlots: {
							customRender: 'action'
						}
					}
				],
				datas: [],
				roles: [],
				mendians: [],
				search:{
					keyword:'',
					mendian_id:0
				}
			}
		},
		created() {
			this.getRoles();
			this.getMendians();
		},
		methods: {
			getMendians(){
				this.$http.api('admin/getAllMendian').then(res=>{
					this.mendians = res.mendian;
				}).catch(res=>{
					console.log(res);
				});
			},
			getLists(){
				if(this.loading==true) return;
				this.loading=true;
				this.$http.api('admin/getShopStaffList',{
					keyword:this.search.keyword,
					mendian_id:this.search.mendian_id,
					limit:this.pagination.pageSize,
					page:this.pagination.current,
				}).then(res=>{
					console.log(res);
					this.pagination.total=res.total;
					this.datas=res.list;
					this.miniapp_status = res.miniapp_status;
					
					this.loading=false;
				}).catch(res=>{
					this.loading=false;
				})
			},
			
			handleTableChange(pagination, filters, sorter) {
				this.pagination.current = pagination.current;
				this.getLists();
			},
			
			
			addStaffAct(){
				this.staff_id=0;
				this.editStaffLoading=true;
			},
			editStaffAct(record){
				this.staff_id=record.staff_id;
				this.editStaffLoading=true;
			},
			cancelEditStaff(){
				this.editStaffLoading=false;
			},
			okEditStaff(){
				this.editStaffLoading=false;
				this.getLists();
			},
			
			
			showMiniappAct(){
				this.showMiniappLoading=true;
			},
			cancelShowMiniapp(){
				this.showMiniappLoading=false;
			},
			delAct(record){
				this.$confirm({
					title:'确认删除这个账号吗？',
					okText:"确定",
					okType:"danger",
					cancelText:"取消",
					onOk : ()=>{
						return new Promise((resolve,reject)=>{
							this.$http.api('admin/leaveShopStaff',{
								staff_id:record.staff_id,
							}).then(res=>{
								this.$message.success('删除成功');
								this.getLists();
							}).catch(res=>{
								console.log(res);
							}).finally(()=>{
								resolve();
							})
						})
					}
				})
			},
			
			toCashier(){
				this.$router.push('/beautiful/cashier/')
			},
			getRoles(){
				this.$http.api('admin/getAllRole').then(res=>{
					this.roles = res.roles;
				}).catch(res=>{
					console.log(res);
				});
			},
			getRoleLabel(role) {
				// console.log('role', role);
				if(!role) return '-';
				// console.log('this.roles',this.roles);

				const found = this.roles.find(item => item.role_id === role.role_id);
				return found ? found.name : '-';

				// const found = this.roles.find((item,index)=>{
				// 	console.log('item.role_id',item.role_id);
				// 	console.log('index',index);
				// });
				// console.log('found',found);
			}
		}
	}
</script>

<style>
	.setting-staff-visit-miniapp{
		border-radius: 4px;
		border: 1px solid #4772FF;
		padding: 4px 8px 4px 8px;
		
		font-size: 12px;
		font-weight: 500;
		color: #4772FF;
		cursor: pointer;
		display: flex;
		align-items: center;
	}
	
	.setting-staff-visit-miniapp img{
		width: 12px;
		height: 12px;
		margin-right: 4px;
	}
</style>
